var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",attrs:{"id":"columns"}},[_c('ActivityBar'),_vm._v(" "),(_vm.loading)?_c('LoadingSpan',{staticClass:"m-3",attrs:{"message":"Loading Page"}}):_c('PageEditorMarkdown',{attrs:{"title":_vm.title,"page-id":_vm.pageId,"public-url":_vm.publicUrl,"content":_vm.content,"content-data":_vm.contentData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }